import { ArrowLeft } from "lucide-react";
import { NavLink, useNavigate } from "react-router-dom";

export function NavBack({path}:{ path?: string}) {
	if (path) {
		return (
			<div className="absolute left-5 top-20 z-50 text-blue-500 group-hover:text-blue-600 group-hover:scale-110 mb-3 drop-shadow hover:drop-shadow-xl transform hover:-translate-y-1 transition-all duration-200 ">
				<NavLink to={path}>
				<ArrowLeft size={32} />
				</NavLink>
			</div>
		)
	} else {
	const navigate = useNavigate();
		return (
			<div 
				onClick={() => navigate(-1)} 
				className="absolute left-5 top-20 z-50 text-blue-500 group-hover:text-blue-600 group-hover:scale-110 mb-3 drop-shadow hover:drop-shadow-xl transform hover:-translate-y-1 transition-all duration-200 ">
				<ArrowLeft size={32} />
			</div>
		)
	}
}

